<h2>Review your station reservation</h2>

<div class="flex justify-content-start ml-2">
  <div class="flex flex-column gap-1">
    <div><i class="pi pi-map-marker icon"></i> {{selectedStation?.Location?.Desc}}</div>
    <div><i class="pi pi-bullseye icon"></i> {{selectedStation?.Name}}</div>
    <div><i class="pi pi-calendar-clock icon"></i> {{selectedDate?.toLocaleDateString()}}, {{selectedTime?.formatedTimeAndRate}}</div>
    <div><i class="pi pi-clock icon"></i> {{durationString}}</div>
    <div class="flex align-items-center gap-1 mb-2">
      <p-checkbox [(ngModel)]="hasGuest" [binary]="true" inputId="hasGuest" />
      <label for="hasGuest">Will you be accompanied by a guest?</label>
    </div>
    @if (hasGuest) {
    <span class="mb-4">{{allowedGuestMessage}}</span>
    <p-floatLabel>
      <p-dropdown [options]="amountOfGuestsOptions" [(ngModel)]="selectedAmountofGuests" inputId="guests" />
      <label for="guests">Amount of guests</label>
    </p-floatLabel>
    }
    <div class="mt-3 mb-4">
      <p-floatLabel>
        <textarea id="float-input" rows="5" cols="30" [(ngModel)]="Notes" pInputTextarea></textarea>
        <label for="float-input">Reservation notes</label>
      </p-floatLabel>
    </div>
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button [routerLink]="['../', routes.SELECT_TIME]" label="BACK"></p-button>
  <p-button (onClick)="onCompleteClick()" label="CONFRIM RESERVATION"></p-button>
</div>
<p-dialog header="Error" [(visible)]="showError">
  <p>
    {{error}}
  </p>
</p-dialog>

@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}